/** Superficie pública del módulo Catálogo. Re-exporta desde domain-api, infra-api, app-api + UI directa. */
// Side-effect import movido a src/init/sessionResetRegistrations.ts (cargado en App.tsx).

// Layered APIs — importar desde estas para evitar require cycles:
//   domain-api: tipos y funciones puras (cero dependencias)
//   infra-api: repos y queries
//   app-api: hooks, use cases, stores
export * from './domain-api';
export * from './infra-api';
export * from './app-api';

// UI — se mantiene directo en public-api para evitar cycles (components/screens importan de otros módulos)
export { sourceLabels, currencyFormatter } from './screens/catalogScreen.constants';
export { CatalogCategorySelectorModal } from './components/CatalogCategorySelectorModal';
export { BulkCoefficientModal } from './components/BulkCoefficientModal';
export { MenuOptionGroupsScreen } from './screens/MenuOptionGroupsScreen';
export { ProductCombosScreen } from './screens/ProductCombosScreen';
export { ComboCreateWizardScreen } from './screens/ComboCreateWizardScreen';
export { ProductRecipeScreen } from './screens/ProductRecipeScreen';
export { ProduceRecipeScreen } from './screens/ProduceRecipeScreen';
export { DisassembleRecipeScreen } from './screens/DisassembleRecipeScreen';
